// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3B3G-","header":"ClearentDisclaimer_header__29bDY","inner":"ClearentDisclaimer_inner__3RDGc"};